module.exports = __webpack_public_path__ + "static/media/who-we-help.f7e202be.png";